// import { Checkbox, Divider, Input, Select } from "antd";
// import React, { useState } from "react";
// import { BiSearchAlt2 } from "react-icons/bi";
// import { fetcher } from "../../../lib/api";
// import useSWR from "swr";

// const Filter = ({ onChange, handleChange, onSearch }) => {
//   const {
//     data: categories,
//     isLoading: categoriesLoading,
//     error: categoriesError,
//     mutate: mutateCategories,
//   } = useSWR("/categories/", fetcher);
//   const [selectedCategory, setSelectedCategory] = useState([]);
//   const options = categories?.map((category) => ({
//     label: category?.name,
//     value: category?.name?.toLowerCase(),
//   }));

//   const handleSingleCheckboxChange = (checkedValue) => {
//     console.log("checkedValue", checkedValue);
//     const newValue =
//       checkedValue.length > 0 ? [checkedValue[checkedValue.length - 1]] : [];
//     setSelectedCategory(newValue);
//     onChange(newValue); // propagate to parent
//   };

//   return (
//     <>
//       <div className="search-product text-[#51525B] font-['Poppins'] block lg:hidden">
//         <Input
//           onChange={(e) => onSearch(e.target.value)}
//           placeholder="Search Product..."
//           suffix={<BiSearchAlt2 />}
//           allowClear
//           className="!bg-white text-[#51525B] font-['Poppins'] text-[13px] w-full my-2"
//         />
//       </div>

//       <div className="mt-2 md:mt-4 lg:mt-20 flex flex-row lg:flex-col gap-[15px]">
//         <div className="search-product hidden lg:block">
//           <Input
//             onChange={(e) => onSearch(e.target.value)}
//             placeholder="Search Product..."
//             suffix={<BiSearchAlt2 />}
//             allowClear
//             className="!bg-white custom-input !text-gray-600 w-[195px] md:w-full"
//           />
//         </div>

//         <div className="categories pl-0 mt-2 md:pl-0 md:mt-0 lg:pl-0 lg:mt-0 w-full">
//           <div className="hidden lg:block">
//             <p className="text-[16px] font-semibold text-[#121212] mb-1">
//               Categories
//             </p>
//             <Divider className="bg-[#ebecf3] my-2" />
//           </div>

//           {/* Multi-select for small screens (unchanged) */}
//           <Select
//             mode="multiple"
//             allowClear
//             className="w-full text-[#51525B] font-['Poppins'] custom-select block lg:hidden"
//             placeholder="Select categories"
//             onChange={onChange}
//             options={options}
//           />

//           {/* Single-select checkbox for large screens */}
//           <Checkbox.Group
//             value={selectedCategory}
//             onChange={handleSingleCheckboxChange}
//             className="hidden lg:flex lg:flex-col gap-2 custom-checkbox capitalize mt-2"
//           >
//             {options?.map((opt) => (
//               <Checkbox key={opt.value} value={opt.value}>
//                 {opt.label}
//               </Checkbox>
//             ))}
//           </Checkbox.Group>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Filter;
import { Input } from "antd";
import React from "react";
import { BiSearchAlt2 } from "react-icons/bi";

const Filter = ({ onSearch }) => {
  return (
    <div className="w-full   mt-4 md:mt-6 lg:mt-9">
      <Input
        onChange={(e) => onSearch(e.target.value)}
        placeholder="Search Product..."
        suffix={<BiSearchAlt2 />}
        allowClear
        className="!bg-white text-[#51525B] font-['Poppins'] text-[13px] md:text-[14px] w-full custom-input"
        size="medium"
      />
    </div>
  );
};

export default Filter;
